import { OBRASOCIAL_ERROR, OBRASOCIAL_SUCCESS, OBRASOCIAL_LOADING, RESET_PORTAL_CONTEXT } from "../ActionTypes";
import obraSocialInitialState from "../initialStates/obraSocialInitialState";

const obraSocial = (state, { payload, type }) => {
  switch (type) {
    case OBRASOCIAL_LOADING:
      return {
        ...state,
        obraSocial: {
          ...state.obraSocial,
          error: false,
          loading: true,
        },
      };
    case OBRASOCIAL_SUCCESS:
      return {
        ...state,
        obraSocial: {
          ...state.obraSocial,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case OBRASOCIAL_ERROR:
      return {
        ...state,
        obraSocial: {
          ...state.obraSocial,
          error: payload,
          loading: false,
        },
      };
    case RESET_PORTAL_CONTEXT:
      return obraSocialInitialState

    default:
      return state;
  }
};

export default obraSocial;